'use client';

import React, { useState } from 'react';

// import Avatar from '@mui/material/Avatar';

import NewsCard from '../../components/News/NewsCardList';
import FullArticleCard from '../../components/ArticleCards/FullArticleCard';
import SocialLinkGroup from '../../components/SocialLinkGroup';
import { getArticlesByAuthor } from '@/utils/articles/client';
import LoadMoreButton from '@/components/Buttons/LoadMoreButton';
import { useOptions, useOptionsDispatch } from '@/providers/options';
import type {
  TypeArticleWithoutUnresolvableLinksResponse,
  TypeAuthorWithoutUnresolvableLinksResponse
} from '@/contentful/types';

type AuthorProps = {
  authorUrlSlug: string;
  author?: TypeAuthorWithoutUnresolvableLinksResponse;
  articles: TypeArticleWithoutUnresolvableLinksResponse[];
  total: number;
  topStories: TypeArticleWithoutUnresolvableLinksResponse[];
};

const PAGE_SIZE = 10;

const Author = ({
  author,
  authorUrlSlug,
  articles: initialArticles,
  total,
  topStories
}: AuthorProps) => {
  const options = useOptions();
  const setOptions = useOptionsDispatch();
  const [articles, setArticles] =
    useState<TypeArticleWithoutUnresolvableLinksResponse[]>(initialArticles);
  const [offset, setOffset] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const authorName = author
    ? `${author?.fields.firstName} ${author?.fields.lastName}`
    : '';

  const searchArticles = async () => {
    setLoading(true);
    const currentOffset = offset + PAGE_SIZE;
    if (currentOffset < total) {
      const newArticles = await getArticlesByAuthor(
        authorUrlSlug,
        currentOffset,
        PAGE_SIZE
      );
      setArticles([...articles, ...newArticles.articles]);
      setOffset(currentOffset);
      setLoading(false);
    }
  };

  if (!author) {
    return null;
  }

  let authorCompany = author.fields.company;
  if (author.fields.company && author.fields.position) {
    authorCompany = `${author.fields.company} - ${author.fields.position}`;
  }

  return (
    <div className='author-container'>
      <div className='theme-container'>
        <div className='standard-page-main'>
          <div className='standard-page__header'>
            <div className='standard-page__title'>
              AUTHOR
              <div className='standard-page__title-underline'>{}</div>
            </div>
          </div>
          <div className='author-body'>
            <div className='author-table'>
              <div className='author-table__header'>
                <div className='author-table__header-inner'>
                  <div className='author-table__header-left'>
                    {/* {author.picture && (
                      <Avatar
                        src={author.picture}
                        alt="Author Picture"
                        className="author-table__avatar"
                      />
                    )} */}
                    <div className='author-table__info'>
                      <div className='author-table__name'>{authorName}</div>
                      <div className='author-table__company'>
                        {authorCompany ?? null}
                      </div>
                    </div>
                  </div>
                  <div className='author-table__header-right'>
                    <SocialLinkGroup
                      website={author.fields.website ?? ''}
                      linkedin={author.fields.linkedIn ?? ''}
                      facebook={author.fields.facebook ?? ''}
                      twitter={author.fields.twitter ?? ''}
                      instagram={author.fields.instagram ?? ''}
                      email={
                        author.fields.emailPublic ? author.fields.email : ''
                      }
                      phone={
                        author.fields.phonePublic
                          ? (author.fields.phoneNumber ?? '')
                          : ''
                      }
                    />
                  </div>
                </div>
                {author.fields.profile && (
                  <div className='author-table__author-desc'>
                    {author.fields.profile}
                  </div>
                )}
              </div>
              <div className='author-table__body'>
                {articles.map((article) => (
                  <FullArticleCard key={article.sys.id} content={article} />
                ))}
              </div>
            </div>
            <div className='author-widget-container'>
              <NewsCard
                title='TOP STORIES'
                data={topStories}
                initialNumToRender={5}
                firstItemHighlight={false}
                itemLayout='standard'
                catLink='/category/Top Stories/'
              />
            </div>
          </div>
          <div className='author-footer'>
            <LoadMoreButton
              loading={loading}
              onClick={() => searchArticles()}
              hasMore={offset + PAGE_SIZE < total}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Author;
